<button class="flex items-center gap-0.5 text-xs py-3 px-3 rounded text-main-600 hover:bg-main-50/30"
  [cdkMenuTriggerFor]="menu" [cdkMenuPosition]="[{overlayX: 'end', overlayY: 'top',originX: 'end',originY: 'bottom'}]">
  <icon-globe [size]="18" class="text-main-600" />
  <span>{{ currentLanguage === 'en' ? 'EN' : 'FR' }}</span>
</button>

<ng-template #menu>
  <div class="translate-y-1.5 p-0.5 bg-white border border-neutral-200 rounded-md flex items-center justify-center">
    <ul cdkMenu class="bg-neutral-200 text-xs rounded-md p-1 w-24 md:w-28 flex flex-col gap-1">
      <li cdkMenuItem>
        <button (click)="toggleLanguage('fr')"
          class="w-full p-2 rounded text-center lg:hover:bg-main-500 lg:hover:text-white"
          [class.bg-white]="currentLanguage === 'fr'">
          {{ 'LANGUAGE.FRENCH' | translate }}
        </button>
      </li>
      <li cdkMenuItem>
        <button (click)="toggleLanguage('en')"
          class="w-full p-2 rounded text-center lg:hover:bg-main-500 lg:hover:text-white"
          [class.bg-white]="currentLanguage === 'en'">
          {{ 'LANGUAGE.ENGLISH' | translate }}
        </button>
      </li>
    </ul>
  </div>
</ng-template>